module.exports = __webpack_public_path__ + "media/images/icn-multi-app-f8782914.png";